import { render, staticRenderFns } from "./MaterialEventTable.vue?vue&type=template&id=7b0ab71c&scoped=true"
import script from "./MaterialEventTable.vue?vue&type=script&lang=js"
export * from "./MaterialEventTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ab71c",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreMaterial/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreMaterial%2FMaterialEvent%2FMaterialEventTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports